/**
 * Primitivas para formularios de Boostrap v3
 */
import React from "react";
import PropTypes from "prop-types";

/**
 * EJEMPLO DE LAYOUT VERTICAL:
 *
 *  <div class="form-group has-error has-feedback">
 *      <label class="control-label" for="inputError2">Input with error</label>
 *      <input type="text" class="form-control" id="inputError2" aria-describedby="inputError2Status">
 *      <span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"></span>
 *      <span id="inputError2Status" class="sr-only">(error)</span>
 *  </div>
 *
 * EJEMPLO DE LAYOUT HORIZONTAL:
 *
 *  <div class="form-group has-error has-feedback">
 *      <label class="col-sm-2 control-label"  for="inputError2">Input with error</label>
 *      <div class="col-sm-10">
 *          <input type="text" class="form-control" id="inputError2" aria-describedby="inputError2Status">
 *          <span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"></span>
 *          <span id="inputError2Status" class="sr-only">(error)</span>
 *      </div>
 *  </div>
 */

/**
 * Bloque de Errores
 */
const ErrorBlock = (props) => {
    if (props.touched && props.errors) {
        return (
            <>
                <span className="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true"></span>
                <div className="help-block">{props.errors}</div>
            </>
        );
    }

    return null;
};
/*
                <ErrorMessage
                    component="div"
                    name={props.name}
                    className="help-block"
                />
*/

ErrorBlock.propTypes = {
    name: PropTypes.string.isRequired,
};

/**
 * Bloque de texto de ayuda
 */
const HelpBlock = (props) => {
    if ((!props.touched || !props.errors) && props.help) {
        return <span className="help-block">{props.help}</span>;
    }

    return null;
};

HelpBlock.propTypes = {
    help: PropTypes.string,
};

/**
 * Bloque para el label
 */
const LabelBlock = (props) => {
    const classForLabel = `col-form-label ${props.labelClassName}`;

    return (
        <label htmlFor={props.name} className={classForLabel}>
            {props.label}
            {props.required && !props.disabled && <span className="text-red"> *</span>}
        </label>
    );
};

LabelBlock.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    labelClassName: PropTypes.string,
    required: PropTypes.bool,
};

/**
 * FormGroup / Opcion b)
 *
 *  a) Podría solo agregar su div y dejar al component real establecer el display.
 *  b) Podría mostrar el label, help y error de forma estandar (menos flexible quizas)
 *
 */
const FormGroupBlock = (props) => {
    const classForGroup = `form-group ${props.touched && props.errors ? "has-error has-feedback" : ""}`;

    if (props.layout === "horizontal") {
        return (
            <div className={classForGroup}>
                <LabelBlock {...props} />
                <div className={props.wrapperClassName}>
                    {props.children}
                    <HelpBlock {...props} />
                    <ErrorBlock {...props} />
                </div>
            </div>
        );
    }
    return (
        <div className={props.wrapperClassName}>
            <div className={classForGroup}>
                <LabelBlock {...props} />
                {props.children}
                <HelpBlock {...props} />
                <ErrorBlock {...props} />
            </div>
        </div>
    );
};
FormGroupBlock.propTypes = {
    layout: PropTypes.oneOf(["horizontal", "vertical"]).isRequired,
    name: PropTypes.string.isRequired,
    wrapperClassName: PropTypes.string,
};

FormGroupBlock.defaultProps = {
    layout: "vertical",
};

export { ErrorBlock, HelpBlock, FormGroupBlock, LabelBlock };
